import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import paths from '../../paths';
import formatDate from '../../utils/formatDate';

export default class NewsSliderItem extends Component {
  static defaultProps = {
    to: paths.advocates.news,
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    announce: PropTypes.string.isRequired,
    createdDate: PropTypes.string.isRequired,
    to: PropTypes.string,
  };

  render() {
    const {
      title, announce, createdDate, to,
    } = this.props;
    return (
      <div className="news-slider-item">
        <div className="news-slider-item-date">
          <i className="icon icon-calendar" />
          {formatDate(createdDate, 'forNews')}
        </div>
        <Link to={to} className="news-slider-item-title">
          {title}
        </Link>
        <div className="news-slider-item-desc" dangerouslySetInnerHTML={{__html: announce}}></div>
      </div>
    );
  }
}
